import { Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from '../features/dashboard/components/Overview/index.js'
import Analytics from '../features/analytics/components/Overview/Overview.jsx'
import PropertyList from '../features/dashboard/components/PropertyList/index.js'
import PropertyDetail from '../features/property/components/PropertyDetail/index.js'
import UserLayout from '../features/user/components/UserLayout/index.js'
import UserList from '../features/user/components/UserList/index.js'
// import UserProfile from '../features/user/components/UserProfile/index.js'
import AgentList from '../features/agent/components/AgentList/index.js'
import AgentProfile from '../features/agent/components/AgentProfile/index.js'
import CustomerList from '../features/customer/components/CustomerList/index.js'
import CustomerProfile from '../features/customer/components/CustomerProfile/index.js'
import Login from '../features/auth/components/Login/index.js'
import Register from '../features/auth/components/Register/index.js'
import ForgotPassword from '../features/auth/components/ForgotPassword/index.js'
import ProtectedRoute from '../components/protected/ProtectedRoute.jsx'
import NotFound from '../components/notfound/NotFound.jsx'
import NotificationList from '../features/notification/components/Notification/NotificationList.jsx'
import Settings from '../features/settings/components/Settings/Settings.jsx'
import Activity from '../features/activity/components/Activity.jsx'
import MessageList from '../features/message/components/MessageList/MessageList.jsx'
import ReviewLayout from '../features/reviews/components/ReviewLayout/ReviewLayout.jsx'
import GeneralReview from '../features/reviews/components/GeneralReview/GeneralReview.jsx'
import SurveyReview from '../features/reviews/components/SurveyReview/SurveyReview.jsx'
import ReportList from '../features/reports/components/ReportList/ReportList.jsx'
import Feedback from '../features/feedback/components/Feedback.jsx'
import Help from '../features/help/components/Help.jsx'
import FAQ from '../features/help/components/FAQ.jsx'
import ContactUs from '../features/help/components/ContactUs.jsx'
import ReportDetails from '../features/reports/components/ReportDetails/ReportDetails.jsx'
import Subscription from '../features/subscription/components/Subscription/Subscription.jsx'
import ChatLog from '../features/chat/components/ChatLog/ChatLog.jsx'
import ChatDetail from '../features/chat/components/ChatDetail/ChatDetail.jsx'
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Private routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/properties" element={<PropertyList />} />
        <Route path="/properties/:propertyId" element={<PropertyDetail />} />
        <Route path="/notifications" element={<NotificationList />} />
        <Route path="/notifications/:notificationId" element={<NotificationList />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/messages" element={<MessageList />} />
        <Route path="/chats/:userId" element={<ChatLog />} />
        <Route path="/chats/:userId/conversation/:conversationId" element={<ChatDetail />} />
        <Route path="/reports" element={<ReportList />} />
        <Route path="/reports/:reportId" element={<ReportDetails />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/help" element={<Help />} />
        <Route path="/help/faq" element={<FAQ />} />
        <Route path="/help/contact" element={<ContactUs />} />

        <Route path="/users" element={<UserLayout />}>
          <Route index element={<UserList />} />
          <Route path="agents" element={<AgentList />} />
          <Route path="customers" element={<CustomerList />} />
        </Route>
        <Route path="/users/customers/:customerId" element={<CustomerProfile />} />
        <Route path="/users/agents/:agentId" element={<AgentProfile />} />
        <Route path="/reviews" element={<ReviewLayout />}>
          <Route index element={<GeneralReview />} />
          <Route path="general" element={<GeneralReview />} />
          <Route path="survey" element={<SurveyReview />} />
        </Route>
        <Route path="/" element={<Navigate replace to="/dashboard" />} />
      </Route>

      {/* Catch-all route for 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes